const BIRTHDAY_CARD_STORAGE_KEY = 'isBirthdayCardHidden';

export const getIsBirthdayCardHidden = () => {
  try {
    const isBirthdayCardHidden = window.localStorage.getItem(BIRTHDAY_CARD_STORAGE_KEY);

    return !!isBirthdayCardHidden;
  } catch {
    return false;
  }
};

export const setIsBirthdayCardHidden = () => {
  try {
    window.localStorage.setItem(BIRTHDAY_CARD_STORAGE_KEY, 'true');
  } catch {
    return;
  }
};
